/**
 * The refusals of new business a client can meet that send them to their Account
 * Executive, never to a dead end (owner, 2026-10-30; S-43). The screen that shows one
 * offers to request the call right there.
 *
 * Chosen by the refusal's CODE, never by its wording: the server's sentence says what
 * happened and that their Account Executive can help, and the screen adds the action.
 * `membership_agreement_required` is deliberately absent: it points the client to the
 * Membership Agreement, a step they can take themselves.
 */
export const EXECUTIVE_REFUSAL_CODES: ReadonlySet<string> = new Set([
  'issuer_no_free_slot',
  'product_closed_to_new_investors',
  'product_not_operable',
  'exit_not_available',
  // A series held to the end of its term: left by a notice of non-renewal, never withdrawn early.
  'early_exit_not_allowed',
  // A notice of non-renewal that has already taken effect can no longer be withdrawn.
  'non_renewal_already_effective',
  // A holding already has its notice of non-renewal open.
  'non_renewal_already_given',
  // The last day to withdraw a notice of non-renewal has passed: the decision is fixed.
  'non_renewal_deadline_passed',
  'liquid_cash_not_implemented',
  'offering_document_unavailable',
  'contract_workflow_unavailable',
  'accreditation_advisor_required',
  'request_unavailable_now',
  'tax_form_needs_review',
  'product_unavailable',
  'product_not_mapped_to_funds',
  'redemption_not_available',
  'funds_position_missing',
]);

/**
 * The note the Account Executive reads with the call request: where the client was. It is
 * for staff, so it is kept out of the screens' text and never translated.
 */
export const CALL_CONTEXT = {
  contracts: 'Contracts page',
  withdrawal: 'Withdrawal request',
  taxForm: 'Tax form review',
  contributionPlan: 'Contribution plan',
  accountBeingConfirmed: 'Contribution: the account for this series is being confirmed',
  seriesNotAvailable: 'From a series page that is not available to them',
  referenceNotIssued: 'Contribution: a contribution reference could not be created',
} as const;

/** The note for a call about one series, naming the screen and the series. */
export function seriesCallContext(screen: string, seriesName: string): string {
  return `${screen}. Series: ${seriesName}.`;
}

export function channelsToExecutive(code: string | null | undefined): boolean {
  return code != null && EXECUTIVE_REFUSAL_CODES.has(code);
}
